var _rect, _rect2, _rect3, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_1979_15904_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.032 -0.032 0 32 32)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1031.25,
    y: -1031.25,
    width: 2062.5,
    height: 2062.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(245, 244, 218, 1) 0deg,rgba(247, 254, 213, 1) 53.8081deg,rgba(204, 254, 255, 1) 133.872deg,rgba(253, 207, 254, 1) 244.386deg,rgba(245, 238, 222, 1) 318.274deg,rgba(245, 244, 218, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 3.5,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.96862745285034180,\"g\":0.99607843160629272,\"b\":0.83529412746429443,\"a\":1.0},\"position\":0.14946706593036652},{\"color\":{\"r\":0.80000001192092896,\"g\":0.99607843160629272,\"b\":1.0,\"a\":1.0},\"position\":0.37186601758003235},{\"color\":{\"r\":0.99215686321258545,\"g\":0.81176471710205078,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.67884975671768188},{\"color\":{\"r\":0.96078431606292725,\"g\":0.93333333730697632,\"b\":0.87058824300765991,\"a\":1.0},\"position\":0.88409465551376343}],\"stopsVar\":[],\"transform\":{\"m00\":3.9188699282725371e-15,\"m01\":-64.0,\"m02\":64.0,\"m10\":64.0,\"m11\":3.9188699282725371e-15,\"m12\":-3.9188699282725371e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 3.5,
    fill: "white",
    fillOpacity: 0.46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 3.5,
    stroke: "#F9FAFB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 7,
    width: 15,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 18,
    y: 7,
    width: 15,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5748 7.41149C24.5111 7.98625 21.5886 9.15235 18.9707 10.8446L32 31L27.5748 7.41149Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5748 7.41149C24.5111 7.98625 21.5886 9.15235 18.9707 10.8446L32 31L27.5748 7.41149Z",
    fill: "#AFD3E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5748 7.41149C24.5111 7.98625 21.5886 9.15235 18.9707 10.8446L32 31L27.5748 7.41149Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-2-outside-1_1979_15904)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 6,
    width: 18,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27,
    y: 6,
    width: 18,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5355 7.4189C33.2652 6.33412 39.1938 7.37258 44.2137 10.3402L32 31L27.5355 7.4189Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5355 7.4189C33.2652 6.33412 39.1938 7.37258 44.2137 10.3402L32 31L27.5355 7.4189Z",
    fill: "#F6AE99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5355 7.4189C33.2652 6.33412 39.1938 7.37258 44.2137 10.3402L32 31L27.5355 7.4189Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-3-outside-2_1979_15904)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-3_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 9,
    width: 26,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31,
    y: 9,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9781 10.2028C48.0986 12.576 51.4213 16.1197 53.5246 20.3843C55.6278 24.6489 56.4169 29.4422 55.7916 34.156L32 31L43.9781 10.2028Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9781 10.2028C48.0986 12.576 51.4213 16.1197 53.5246 20.3843C55.6278 24.6489 56.4169 29.4422 55.7916 34.156L32 31L43.9781 10.2028Z",
    fill: "#B97A95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9781 10.2028C48.0986 12.576 51.4213 16.1197 53.5246 20.3843C55.6278 24.6489 56.4169 29.4422 55.7916 34.156L32 31L43.9781 10.2028Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-4-outside-3_1979_15904)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-4_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 30,
    width: 26,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31,
    y: 30,
    width: 26,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7982 34.1056C54.9745 40.4173 51.6773 46.1433 46.6319 50.0239L32 31L55.7982 34.1056Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7982 34.1056C54.9745 40.4173 51.6773 46.1433 46.6319 50.0239L32 31L55.7982 34.1056Z",
    fill: "#94D4D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7982 34.1056C54.9745 40.4173 51.6773 46.1433 46.6319 50.0239L32 31L55.7982 34.1056Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-5-outside-4_1979_15904)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-5_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 30,
    width: 41,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 30,
    width: 41,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8338 49.8668C43.2485 52.6857 38.9343 54.4247 34.3963 54.8801C29.8584 55.3354 25.2846 54.4884 21.2107 52.4381C17.1368 50.3878 13.7314 47.2191 11.3934 43.3032C9.05544 39.3873 7.88161 34.8863 8.00943 30.3274L32 31L46.8338 49.8668Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8338 49.8668C43.2485 52.6857 38.9343 54.4247 34.3963 54.8801C29.8584 55.3354 25.2846 54.4884 21.2107 52.4381C17.1368 50.3878 13.7314 47.2191 11.3934 43.3032C9.05544 39.3873 7.88161 34.8863 8.00943 30.3274L32 31L46.8338 49.8668Z",
    fill: "#FF7A5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8338 49.8668C43.2485 52.6857 38.9343 54.4247 34.3963 54.8801C29.8584 55.3354 25.2846 54.4884 21.2107 52.4381C17.1368 50.3878 13.7314 47.2191 11.3934 43.3032C9.05544 39.3873 7.88161 34.8863 8.00943 30.3274L32 31L46.8338 49.8668Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-6-outside-5_1979_15904)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-6_1979_15904",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 26,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 10,
    width: 26,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2818 10.6469C15.8497 12.7916 13.0156 15.7694 11.0432 19.3033C9.0708 22.8372 8.02409 26.8126 8.00042 30.8596L32 31L19.2818 10.6469Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2818 10.6469C15.8497 12.7916 13.0156 15.7694 11.0432 19.3033C9.0708 22.8372 8.02409 26.8126 8.00042 30.8596L32 31L19.2818 10.6469Z",
    fill: "#F5CC3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2818 10.6469C15.8497 12.7916 13.0156 15.7694 11.0432 19.3033C9.0708 22.8372 8.02409 26.8126 8.00042 30.8596L32 31L19.2818 10.6469Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-7-outside-6_1979_15904)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 31C51.2 36.302 49.0517 41.102 45.5768 44.5768C42.1019 48.0516 37.302 50.2 32 50.2C26.698 50.2 21.898 48.0517 18.4232 44.5768C14.9484 41.1019 12.8 36.302 12.8 31C12.8 25.698 14.9483 20.898 18.4232 17.4232C21.8981 13.9484 26.698 11.8 32 11.8C37.302 11.8 42.102 13.9483 45.5768 17.4232C49.0516 20.8981 51.2 25.698 51.2 31Z",
    fill: "#EFE9FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1626 43.1626C47.2776 40.0477 49.2 35.7504 49.2 31C49.2 26.2496 47.2776 21.9524 44.1626 18.8374C41.0477 15.7224 36.7505 13.8 32 13.8C27.2496 13.8 22.9525 15.7225 19.8374 18.8374C16.7224 21.9523 14.8 26.2496 14.8 31C14.8 35.7504 16.7225 40.0476 19.8374 43.1626C22.9524 46.2776 27.2496 48.2 32 48.2C36.7504 48.2 41.0476 46.2776 44.1626 43.1626ZM45.5768 44.5768C49.0517 41.102 51.2 36.302 51.2 31C51.2 25.698 49.0516 20.8981 45.5768 17.4232C42.102 13.9483 37.302 11.8 32 11.8C26.698 11.8 21.8981 13.9484 18.4232 17.4232C14.9483 20.898 12.8 25.698 12.8 31C12.8 36.302 14.9484 41.1019 18.4232 44.5768C21.898 48.0517 26.698 50.2 32 50.2C37.302 50.2 42.1019 48.0516 45.5768 44.5768Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0555 31.1999C26.688 31.1999 26.3902 30.9019 26.3902 30.5345C26.3902 30.1156 26.0493 29.7747 25.6304 29.7747C25.2115 29.7747 24.8707 30.1156 24.8707 30.5345C24.8707 30.9019 24.5729 31.1999 24.2054 31.1999C23.8378 31.1999 23.54 30.9019 23.54 30.5345C23.54 29.3818 24.4777 28.444 25.6304 28.444C26.7831 28.444 27.7209 29.3818 27.7209 30.5345C27.7209 30.9019 27.423 31.1999 27.0555 31.1999Z",
    fill: "#423E4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7946 31.1999C39.4271 31.1999 39.1293 30.9019 39.1293 30.5345C39.1293 30.1156 38.7884 29.7747 38.3696 29.7747C37.9508 29.7747 37.6099 30.1156 37.6099 30.5345C37.6099 30.9019 37.3121 31.1999 36.9445 31.1999C36.577 31.1999 36.2792 30.9019 36.2792 30.5345C36.2792 29.3818 37.2169 28.444 38.3696 28.444C39.5223 28.444 40.46 29.3818 40.46 30.5345C40.46 30.9019 40.1621 31.1999 39.7946 31.1999Z",
    fill: "#423E4F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0017 33.556C31.2301 33.556 30.4962 33.2218 29.9884 32.6391C29.747 32.362 29.7758 31.9418 30.0528 31.7003C30.3297 31.4588 30.7501 31.4876 30.9916 31.7647C31.2467 32.0573 31.6148 32.2251 32.0018 32.2251C32.3887 32.2251 32.7568 32.0573 33.0118 31.7647C33.2531 31.4876 33.6734 31.4588 33.9506 31.7002C34.2275 31.9416 34.2565 32.3618 34.0151 32.639C33.5072 33.2218 32.7733 33.556 32.0017 33.556Z",
    fill: "#423E4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_1979_15904_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 3.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.cb81ea8c7bd5331a84cf3c4fc5ac97f1.svg";
export { ForwardRef as ReactComponent };